<!-- Vanity Coupon Modal -->
<p-dialog
  [visible]="visible()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '1025px': '100vw', '354px': '100vw' }"
  [style]="{ width: '750px' }"
  styleClass="no-header-modal no-overflow-content"
  (onHide)="CloseCouponPopup()"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="p-2 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300"
    >
      <h2 class="mb-0 text-sm">
        {{ 'ADMIN.COUPON.VANITY_COUPON' | translate }}
      </h2>
      <div class="flex align-items-center justify-content-end">
        <p-button
          (click)="DownloadCSV()"
          styleClass="p-button-outlined py-2 px-3 justify-content-center border-primary white-space-nowrap text-sm mr-3"
        >
          <img
            width="17"
            src="/assets/img/icons/microsoft-excel.svg"
            alt="Image"
          />
          <span class="ml-2">{{
            'ADMIN.COUPON.DOWNLOAD_CSV' | translate
          }}</span>
        </p-button>
        <p-button
          (click)="openAddCoupon()"
          styleClass="text-sm mr-3"
          icon="fa fa-plus"
          [label]="'ADMIN.COUPON.LBL_GENERATE' | translate"
        />
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="CloseCouponPopup()"
        ></div>
      </div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="">
      <app-data-grid
        [loading]="loading | async"
        [columnData]="coupons$"
        [columns]="columns"
        [EmptyState]="emptyStateComponent$"
        [paginator]="false"
        [selectable]="false"
        (onAction)="onActionEvent($event)"
        [gridName]="'vanity-coupon-list'"
      />
    </div>
    <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Vanity Coupon Modal -->

<!-- Generate Coupons Modal -->
@if (generateCouponsModal | async) {
  <p-dialog
    [visible]="generateCouponsModal"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '1025px': '100vw', '354px': '100vw' }"
    [style]="{ width: '25vw' }"
    styleClass="no-header-modal no-overflow-content"
    (onHide)="closeAddCouponPopup()"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="p-2 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">
          {{ 'ADMIN.COUPON.GENERATE_MORE_COUPONS' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeAddCouponPopup()"
        ></div>
      </div>
      <!-- Header -->
      <form [formGroup]="formGroup" (ngSubmit)="formSubmit()">
        <!-- Content -->
        <!-- Content -->
        <div class="p-2 md:p-3 surface-50 relative">
          <input type="hidden" formControlName="method" />
          <!-- Form Group -->
          <div class="mb-3">
            <label class="font-medium text-700 text-xs mb-2 block uppercase"
              >{{ 'ADMIN.COUPON.LBL_FIXED_COUPON' | translate
              }}<sup class="p-error">*</sup></label
            >
            <input
              type="text"
              pInputText
              class="w-full text-sm"
              [placeholder]="'ADMIN.COUPON.COUPON_NAME' | translate"
              formControlName="coupon_name"
            />
            @if (nameControl.touched && nameControl.invalid) {
              <app-error-msg
                [errors]="nameControl.errors"
                [fieldLabel]="'ADMIN.COUPON.COUPON_CODE' | translate"
              />
            }
          </div>
          <!-- Form Group -->
          <!-- Form Group -->
          <div class="">
            <label class="font-medium text-700 text-xs mb-2 block uppercase"
              >{{ 'ADMIN.COUPON.LBL_NO_OF_TIMES_USED' | translate }}
              <sup class="p-error">*</sup></label
            >
            <!-- <p-inputNumber mode="decimal" inputStyleClass="w-full" styleClass="w-full" class="w-full text-sm"
                [maxlength]="4" [format]="false" formControlName="max_redepmtion_count">
              </p-inputNumber> -->
            <app-shared-input-number
              [formGroup]="formGroup"
              [controlName]="maxRedemptionControl"
              [styleClass]="'w-full text-sm'"
              [conditionToFormat]="false"
              [mode]="'number'"
            />
            @if (maxRedemptionControl.touched && maxRedemptionControl.invalid) {
              <app-error-msg
                [errors]="maxRedemptionControl.errors"
                [fieldLabel]="'ADMIN.COUPON.MAX_REDEMPTION_COUNT' | translate"
              />
            }
          </div>
          <!-- Form Group -->
        </div>
        <!-- Content -->
        <!-- Modal Footer -->
        <div
          class="p-3 border-top-1 border-300 flex align-items-center justify-content-between"
        >
          <div class="w-4">
            <button
              pButton
              (click)="closeAddCouponPopup()"
              [label]="'ADMIN.COUPON.BUTTON_CANCEL' | translate"
              type="button"
              class="p-button-link text-sm"
            ></button>
          </div>
          <div class="w-8 text-right">
            <button
              pButton
              type="submit"
              [disabled]="!formGroup.valid"
              [loading]="loadingBtn"
              [label]="'ADMIN.COUPON.BTN_GENERATE' | translate"
              class="text-sm"
            ></button>
          </div>
        </div>
        <!-- Modal Footer -->
      </form>
    </ng-template>
  </p-dialog>
}
<!-- Generate Coupons Modal -->
